import React, { useEffect } from 'react'
import dayjs from 'dayjs'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import InputGroup from 'react-bootstrap/InputGroup'
import { useFieldArray, useFormContext } from 'react-hook-form'

const InputComprobante = ({
  name,
  index,
  disabled = false,
  pago,
  methods,
  bimestre,
  arrayName
}) => (
  <Form.Group className="col-6">
    <Form.Label>{`N° Comprobante`}</Form.Label>
    <Form.Control
      type="text"
      placeholder="Comprobante Nro"
      name={`${name}.${index}.pagComprobante`}
      disabled={disabled}
      defaultValue={pago.pagComprobante}
      ref={methods.register({
        required: {
          value: true,
          message: 'Es necesario ingresar el nro comprobante'
        },
        pattern: { value: /^\d+$/, message: 'Sólo puede incluir números.' }
      })}
      isInvalid={
        !disabled &&
        !!methods.errors?.[bimestre]?.pagos?.[arrayName]?.[index]
          ?.pagComprobante
      }
      isValid={
        !disabled &&
        !methods.errors?.[bimestre]?.pagos?.[arrayName]?.[index]
          ?.pagComprobante &&
        methods.getValues(`${name}.${index}.pagComprobante`)
      }
    />
    <Form.Control.Feedback type="invalid">
      {
        methods.errors?.[bimestre]?.pagos?.[arrayName]?.[index]?.pagComprobante
          ?.message
      }
    </Form.Control.Feedback>
  </Form.Group>
)
const InputBocaRecaudadora = ({
  name,
  index,
  disabled = false,
  pago,
  methods,
  bimestre,
  arrayName
}) => (
  <Form.Group className="col-6">
    <Form.Label>{`Boca Recaudadora`}</Form.Label>
    <Form.Control
      type="text"
      placeholder="Boca Recaudadora"
      name={`${name}.${index}.pagBocaRecaudadora`}
      disabled={disabled}
      defaultValue={pago.pagBocaRecaudadora}
      ref={methods.register({
        required: {
          value: true,
          message: 'Es necesario ingresar boca recudadora'
        }
      })}
      isInvalid={
        !disabled &&
        !!methods.errors?.[bimestre]?.pagos?.[arrayName]?.[index]
          ?.pagBocaRecaudadora
      }
      isValid={
        !disabled &&
        !methods.errors?.[bimestre]?.pagos?.[arrayName]?.[index]
          ?.pagBocaRecaudadora &&
        methods.getValues(`${name}.${index}.pagBocaRecaudadora`)
      }
    />
    <Form.Control.Feedback type="invalid">
      {
        methods.errors?.[bimestre]?.pagos?.[arrayName]?.[index]
          ?.pagBocaRecaudadora?.message
      }
    </Form.Control.Feedback>
  </Form.Group>
)
const InputTotalAbonado = ({
  name,
  index,
  disabled = false,
  pago,
  methods,
  bimestre,
  arrayName
}) => (
  <Form.Group className="col-6">
    <Form.Label>{`Total Abonado`}</Form.Label>
    <InputGroup>
      <InputGroup.Prepend className="input-group-addon" style={{ top: '25px' }}>
        <InputGroup.Text id="prependImportePago">$</InputGroup.Text>
      </InputGroup.Prepend>
      <Form.Control
        as="input"
        type="number"
        placeholder="Importe"
        aria-describedby="prependImportePago"
        name={`${name}.${index}.importe`}
        disabled={disabled}
        defaultValue={pago.pagImporteAbonado}
        ref={methods.register({
          required: {
            value: true,
            message: 'Es necesario ingresar total abonado.'
          },
          min: {
            value: 1,
            message: 'El total abonado debe ser un número positivo'
          }
        })}
        isInvalid={
          !disabled &&
          !!methods.errors?.[bimestre]?.pagos?.[arrayName]?.[index]?.importe
        }
        isValid={
          !disabled &&
          !methods.errors?.[bimestre]?.pagos?.[arrayName]?.[index]?.importe &&
          methods.getValues(`${name}.${index}.importe`)
        }
      />
      <Form.Control.Feedback type="invalid">
        {
          methods.errors?.[bimestre]?.pagos?.[arrayName]?.[index]?.importe
            ?.message
        }
      </Form.Control.Feedback>
    </InputGroup>
  </Form.Group>
)
const InputFechaPago = ({
  name,
  index,
  disabled = false,
  pago,
  methods,
  bimestre,
  arrayName
}) => (
  <Form.Group className="col-6">
    <Form.Label>{`Fecha de Pago`}</Form.Label>
    <Form.Control
      type="date"
      placeholder="Fecha de Pago"
      name={`${name}.${index}.pagFecReg`}
      disabled={disabled}
      defaultValue={
        pago.tshTipoCarga === 'A' && pago.pagFecReg === ''
          ? pago.pagFecReg
          : dayjs(pago.pagFecReg, 'YYYY-MM-DD+h:mm:ii').format('YYYY-MM-DD')
      }
      ref={methods.register({
        required: { value: true, message: 'Es necesario ingresar fecha.' },
        validate: {
          value: (value) =>
            dayjs(value).diff(dayjs(new Date()).format('YYYY-MM-DD')) <= 0
        }
      })}
      isInvalid={
        !disabled &&
        !!methods.errors?.[bimestre]?.pagos?.[arrayName]?.[index]?.pagFecReg
      }
      isValid={
        !disabled &&
        !methods.errors?.[bimestre]?.pagos?.[arrayName]?.[index]?.pagFecReg &&
        methods.getValues(`${name}.${index}.pagFecReg`)
      }
    />
    <Form.Control.Feedback type="invalid">
      {methods.errors?.[bimestre]?.pagos?.[arrayName]?.[index]?.pagFecReg
        ?.message ||
        (methods.errors?.[bimestre]?.pagos?.[arrayName]?.[index]?.pagFecReg &&
          'La fecha de pago no puede ser mayor a la fecha actual.')}
    </Form.Control.Feedback>
  </Form.Group>
)

const DatosPago = ({
  name,
  bimestre,
  legajo,
  bimes,
  arrayName,
  item,
  pagosRealizados
}) => {
  const { register, errors, getValues, control } = useFormContext()
  const { fields: pagosNuevos, remove } = useFieldArray({ control, name })
  const {
    fields: pagosFiltradosNuevo,
    append: agregarPago,
    remove: quitarPago
  } = useFieldArray({ control, name })

  const pagosFiltrados = pagosRealizados
    ?.filter(
      (datosPago) =>
        datosPago.pagLegajo === legajo && datosPago.tshBimestre === bimes
    )
    .sort((a, b) => a.tshSecuencia - b.tshSecuencia)

  const cantidadPagoBBDD = pagosFiltrados.length

  useEffect(() => {
    if (!pagosFiltradosNuevo.length) {
      for (const a in pagosFiltrados) {
        agregarPago(pagosFiltrados[a])
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagosFiltrados])

  const pagos_realizados = pagosFiltradosNuevo.map((pago, index) => {
    const disabled = pago.tshTipoCarga === 'W'
    return (
      <div key={pago.id}>
        <Row className="align-items-center">
          <Col md={disabled ? '12' : '11'}>
            <Form.Row>
              <InputComprobante
                name={name}
                bimestre={bimestre}
                arrayName={arrayName}
                index={index}
                disabled={disabled}
                pago={pago}
                methods={{ register, errors, getValues }}
              />
              <InputBocaRecaudadora
                name={name}
                bimestre={bimestre}
                arrayName={arrayName}
                index={index}
                disabled={disabled}
                pago={pago}
                methods={{ register, errors, getValues }}
              />
            </Form.Row>
            <Form.Row>
              <InputTotalAbonado
                name={name}
                bimestre={bimestre}
                arrayName={arrayName}
                index={index}
                disabled={disabled}
                pago={pago}
                methods={{ register, errors, getValues }}
              />
              {!disabled && (
                <InputFechaPago
                  name={name}
                  bimestre={bimestre}
                  arrayName={arrayName}
                  index={index}
                  disabled={disabled}
                  pago={pago}
                  methods={{ register, errors, getValues }}
                />
              )}
            </Form.Row>
            <input
              style={{ display: 'none' }}
              type="text"
              name={`${name}.${index}.tshBimestre`}
              defaultValue={bimes}
              ref={register()}
            />
            <input
              style={{ display: 'none' }}
              type="text"
              name={`${name}.${index}.pagLegajo`}
              defaultValue={legajo}
              ref={register()}
            />
            <input
              style={{ display: 'none' }}
              type="text"
              name={`${name}.${index}.tshTipoCarga`}
              defaultValue={pago.tshTipoCarga}
              ref={register()}
            />
            <input
              style={{ display: 'none' }}
              type="text"
              name={`${name}.${index}.tshSecuencia`}
              defaultValue={index}
              ref={register()}
            />
          </Col>
          {!disabled && (
            <button
              className="m-0 py-1 px-2 border-0 rounded bg-white"
              onClick={() => quitarPago(index)}
            >
              <i className="material-icons delete"></i>
            </button>
          )}
        </Row>
      </div>
    )
  })

  const pagos_nuevos = () => {
    return (
      <>
        {pagosNuevos?.map((pago, index) => (
          <div key={pago.id}>
            <Row className="align-itmes-center">
              <Col md={11}>
                <Form.Row>
                  <InputComprobante
                    name={name}
                    bimestre={bimestre}
                    arrayName={arrayName}
                    index={index + cantidadPagoBBDD}
                    pago={pago}
                    methods={{ register, errors, getValues }}
                  />
                  <InputBocaRecaudadora
                    name={name}
                    bimestre={bimestre}
                    arrayName={arrayName}
                    index={index + cantidadPagoBBDD}
                    pago={pago}
                    methods={{ register, errors, getValues }}
                  />
                </Form.Row>
                <Form.Row>
                  <InputTotalAbonado
                    name={name}
                    bimestre={bimestre}
                    arrayName={arrayName}
                    index={index + cantidadPagoBBDD}
                    pago={pago}
                    methods={{ register, errors, getValues }}
                  />
                  <InputFechaPago
                    name={name}
                    bimestre={bimestre}
                    arrayName={arrayName}
                    index={index + cantidadPagoBBDD}
                    disabled={false}
                    pago={pago}
                    methods={{ register, errors, getValues }}
                  />
                </Form.Row>
                <input
                  style={{ display: 'none' }}
                  type="text"
                  name={`${name}.${index + cantidadPagoBBDD}.tshBimestre`}
                  defaultValue={bimes}
                  ref={register}
                />
                <input
                  style={{ display: 'none' }}
                  type="text"
                  name={`${name}.${index + cantidadPagoBBDD}.pagLegajo`}
                  defaultValue={legajo}
                  ref={register}
                />
                <input
                  style={{ display: 'none' }}
                  type="text"
                  name={`${name}.${index + cantidadPagoBBDD}.tshTipoCarga`}
                  defaultValue="A"
                  ref={register}
                />
                <input
                  style={{ display: 'none' }}
                  type="text"
                  name={`${name}.${index + cantidadPagoBBDD}.tshSecuencia`}
                  defaultValue={index + cantidadPagoBBDD}
                  ref={register}
                />
              </Col>
              <button
                className="m-0 py-1 px-2 border-0 rounded bg-white"
                onClick={() => remove(index)}
              >
                <i className="material-icons delete"></i>
              </button>
            </Row>
          </div>
        ))}
        <Button
          variant="outline-primary"
          className="btn-block mb-5"
          onClick={() => agregarPago(item)}
        >
          Agregar Pago
        </Button>
      </>
    )
  }
  return (
    <>
      {pagos_realizados}
      {pagos_nuevos()}
    </>
  )
}

export default DatosPago
